import { Component, OnInit, ViewChild, TemplateRef, EventEmitter, ViewEncapsulation} from '@angular/core';
import { ROUTE_ANIMATION, ROUTE_ANIMATION_HOST } from '../../app.routing.animation';
import { MzModalService } from 'ngx-materialize';

import { searchBitaMovFilters} from '../../_models/bitacora-mov.models';
import { ZeroService } from '../../_services/zero/zero.service';
import { Router } from '@angular/router';
import { REST_SERVICES} from '../../_services/settings';
import { Globals } from '../../_services/zero/globals';
import { ModalDiffComponent } from './modal-diff/modal-diff.component'
import { DateOnlyPipe } from '../../_services/DateOnlyPipe';
import { ToastrService } from 'ngx-toastr';
import { Page } from 'src/app/_models/page.model';
import { ReporteRequest } from 'src/app/_models/reportes.model';

@Component({
  selector: 'app-bitacorramov',
  templateUrl: './bitacorramov.component.html',
  styleUrls: ['../../semantic/datatable/datatable.component.scss', './bitacoramov.component.css'],
  host: ROUTE_ANIMATION_HOST, 
  animations: [ROUTE_ANIMATION],
  encapsulation: ViewEncapsulation.None
})
export class BitacorramovComponent implements OnInit {
  public page: Page;
  public columnsDataTable: Array<any>;
  public rowsDataTable:any = [];
  public titleToGroup: any = "BIN  : ";
  public exportActivo: boolean = true;

  @ViewChild('templateButton') public columButtonTemplate: TemplateRef<any>;
  public onEventTemplate:EventEmitter<Object>;
  public messages = {
    // Message to show when array is presented
    // but contains no values
    emptyMessage: 'No hay información para mostrar',
  
    // Footer total message
    totalMessage: 'total'
  };

  public filtersForSearches: searchBitaMovFilters;

  public options: Pickadate.DateOptions;

  banderaDatos : boolean = false;
  
  constructor(private router : Router,
              private zeroService: ZeroService, 
              private globals: Globals, 
              private modalService: MzModalService,
              private toast: ToastrService,
              ) { 
        this.options = globals.optionsByPickerdate;
        this.page = new Page();
        this.onEventTemplate = new EventEmitter();
    }

  ngOnInit() {
    this.columnsDataTable = 
      [
        { sortable: false, prop : "fecha", name : "FECHA",  pipe: new DateOnlyPipe('en-MX'), width: 180 },
        // { prop : "dscBin", name : "Bin" },
        //{ sortable: false, prop : "idBin", name : "ID_BIN" },
        { sortable: false, prop : "dscEstatusBin", name : "ESTATUS" },
        { sortable: false, prop : "dscAccion", name : "ACCIÓN" },
        { sortable: false, prop : "usuario", name : "USUARIO" },
        { sortable: false, prop : "dscBanco", name : "BANCO" },
        { sortable: false, prop : "rol", name : "ROL" },
        { sortable: false, prop : "modulo", name : "MÓDULO" },
        { sortable: false, prop : "comentarioOpe", name : "COMENTARIO" }, 
        { sortable: false, name: "DETALLE BIN", cellTemplate: this.columButtonTemplate}
      ];
    this.filtersForSearches = new searchBitaMovFilters();
  }

  setPage(pageInfo) {
    this.page.pageNumber = pageInfo.offset + 1;
    this.buscarBin();
  }

  buscarFiltrosBin() {
    this.page.pageNumber = 1;
    this.buscarBin();
  }

  onclickTemplate( target, rowData, accion) {
    this.onEventTemplate.emit({
      targetSelect: target,
      rowSelect: rowData,
      accion: accion, 
    });
  }

  limpiar() {
    this.filtersForSearches = new searchBitaMovFilters();
    this.exportActivo = true;
  }

  buscarBin() {
    this.filtersForSearches;
    let scope = this;
    if (this.filtersForSearches.fechaInicio != undefined && this.filtersForSearches.fechaInicio.trim().length == 0) {
      this.filtersForSearches.fechaInicio = null;
    }

    if (this.filtersForSearches.fechaFin != undefined && this.filtersForSearches.fechaFin.trim().length == 0) {
      this.filtersForSearches.fechaFin = null;
    }
    this.filtersForSearches.paginaActual = this.page.pageNumber;
    if((undefined == this.filtersForSearches.fechaInicio && undefined == this.filtersForSearches.fechaFin) || ( this.filtersForSearches.fechaInicio <= this.filtersForSearches.fechaFin)) {
      scope.zeroService.request({
        isSingleResponse: false,
        uri: REST_SERVICES.search_bitacora_movimientos,
        method: "POST", showInfo: true,
        params: this.filtersForSearches,
        ok: (response) => {      
          if (response.responsecode == "0") {
            if (response.sizeResult > 0)  {
              response.response.forEach(element => {
                element.modulo = element.modulo.toUpperCase();
                element.dscEstatusBin = element.dscEstatusBin.toUpperCase(); 
                if (element.comentarioOpe) {
                  element.comentarioOpe = element.comentarioOpe.toUpperCase();
                }
                scope.page.totalElements = element.totalRegistros != null ? element.totalRegistros : 0;
                scope.rowsDataTable = response.response;          
              });
              
              if (this.page.pageNumber > 0) {
                scope.page.pageNumber = this.page.pageNumber-1;
              } else {
                scope.page.pageNumber = 0;
              }
              
              scope.page.totalPages = this.page.totalElements/6;

              scope.toast.success("<h5>Mensaje de sistema...</h5> <span>" + response.responseMessage + "</span>", "",
                { closeButton: false, enableHtml: true, disableTimeOut: false }
              );
              this.exportActivo = false;
            } else {

              // sin resultados de busqueda
              this.rowsDataTable = [];      
              scope.page.pageNumber = 0;
              scope.page.totalPages = 0;    
              scope.page.totalElements = 0;
              this.exportActivo = true;
              scope.toast.warning("<h5>Mensaje de sistema...</h5> <span>" + response.responseMessage + "</span>", "",
                { closeButton: false, enableHtml: true, disableTimeOut: false }
              );
            }
          } else {
            // sin resultados de busqueda
            this.rowsDataTable = [];      
            scope.page.pageNumber = 0;
            scope.page.totalPages = 0;
            this.exportActivo = true;    
          } 
          
        }      
      });
    } else if (this.filtersForSearches.fechaInicio == undefined  && this.filtersForSearches.fechaFin != undefined){
      this.toast.warning('<h5>Mensaje de sistema...</h5>Se requiere la fecha inicio<span></span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
    } else if (this.filtersForSearches.fechaInicio != undefined && this.filtersForSearches.fechaFin == undefined) {
      this.toast.warning('<h5>Mensaje de sistema...</h5>Se requiere la fecha fin<span></span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
    } else {
      this.toast.warning('<h5>Mensaje de sistema...</h5>La fecha inicio no puede ser mayor que la fecha fin <span></span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
    }
  }

  // boton de 
  onclickDetailRow(target: HTMLElement, row: Object){
    this.modalService.open(ModalDiffComponent, { 'regBitacora': row });
  }

  validarNumberBin(e:KeyboardEvent, valor:any ){
    if ( e.keyCode < 48 || e.keyCode > 57   || valor &&  valor.toString().length > 5  ){
      return false;
    }
  }
  
  exportarExcel() {
    
    this.filtersForSearches;
    let scope = this;
    if (this.filtersForSearches.fechaInicio != undefined && this.filtersForSearches.fechaInicio.trim().length == 0) {
      this.filtersForSearches.fechaInicio = null;
    }

    if (this.filtersForSearches.fechaFin != undefined && this.filtersForSearches.fechaFin.trim().length == 0) {
      this.filtersForSearches.fechaFin = null;
    }
    this.filtersForSearches.pdf = false;

    if((undefined == this.filtersForSearches.fechaInicio && undefined == this.filtersForSearches.fechaFin) || ( this.filtersForSearches.fechaInicio <= this.filtersForSearches.fechaFin)) {
      this.reporteBitacoraRequest();
    } else if (this.filtersForSearches.fechaInicio == undefined  && this.filtersForSearches.fechaFin != undefined){
      this.toast.warning('<h5>Mensaje de sistema...</h5>Se requiere la fecha inicio<span></span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
    } else if (this.filtersForSearches.fechaInicio != undefined && this.filtersForSearches.fechaFin == undefined) {
      this.toast.warning('<h5>Mensaje de sistema...</h5>Se requiere la fecha fin<span></span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
    } else {
      this.toast.warning('<h5>Mensaje de sistema...</h5>La fecha inicio no puede ser mayor que la fecha fin <span></span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
    }
  }

  exportarPdf() {
    
    this.filtersForSearches;
    let scope = this;
    if (this.filtersForSearches.fechaInicio != undefined && this.filtersForSearches.fechaInicio.trim().length == 0) {
      this.filtersForSearches.fechaInicio = null;
    }

    if (this.filtersForSearches.fechaFin != undefined && this.filtersForSearches.fechaFin.trim().length == 0) {
      this.filtersForSearches.fechaFin = null;
    }
    this.filtersForSearches.pdf = true;

    if((undefined == this.filtersForSearches.fechaInicio && undefined == this.filtersForSearches.fechaFin) || ( this.filtersForSearches.fechaInicio <= this.filtersForSearches.fechaFin)) {
      this.reporteBitacoraRequest();
    } else if (this.filtersForSearches.fechaInicio == undefined  && this.filtersForSearches.fechaFin != undefined){
      this.toast.warning('<h5>Mensaje de sistema...</h5>Se requiere la fecha inicio<span></span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
    } else if (this.filtersForSearches.fechaInicio != undefined && this.filtersForSearches.fechaFin == undefined) {
      this.toast.warning('<h5>Mensaje de sistema...</h5>Se requiere la fecha fin<span></span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
    } else {
      this.toast.warning('<h5>Mensaje de sistema...</h5>La fecha inicio no puede ser mayor que la fecha fin <span></span>', "",
            { closeButton: false, enableHtml: true, disableTimeOut: false });
    }
  }

  reporteBitacoraRequest() {
    let scope = this;
    scope.zeroService.request({
      isSingleResponse: false,
      uri: REST_SERVICES.EXPORTAR_EXCEL_BITACORA_MOVIMIENTOS,
      method: "POST",
      showInfo: true,
      showLoading: true,
      params: scope.filtersForSearches,
      ok: (response) => {
        console.log(response);
        this.procesaResponse(response);
      },
    });
  }

  private procesaResponse(response) {
    if (response.response.archivoReporte != null) {
      this.toast.success(
        "<h5>Mensaje de sistema...</h5>El reporte " + `${response.response.nombre}`+", se estará generando y se notificara cuando este disponible para su descarga. <span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    } else {
      this.toast.warning(
        "<h5>Mensaje de sistema...</h5>Error al generar el reporte de bines<span></span>",
        "",
        { closeButton: false, enableHtml: true, disableTimeOut: false }
      );
    }
  }
}

